/** Integration keys from saveAiVisibilityStore / websiteKeys array */

export const SETUP_WEBSITE_ID_KEY = "cb_ai_visibility_setup_website_id";

export function getValueForKey(websiteKeys, keyName) {
	if (!Array.isArray(websiteKeys)) return "";
	const keyItem = websiteKeys.find(
		(item) => item?.websiteIntegrationKey === keyName
	);
	return keyItem?.websiteIntegrationValue ?? "";
}

/** True when websiteKeys includes liveChat = enable (case-insensitive). */
export function isLiveChatEnabled(websiteKeys) {
	return String(getValueForKey(websiteKeys, "liveChat")).trim().toLowerCase() === "enable";
}

export function isLiveChatVisitorHistoryEnabled(websiteKeys) {
	return (
		String(getValueForKey(websiteKeys, "liveChatVisitorHistory")).trim().toLowerCase() ===
		"enable"
	);
}

export const AI_VISIBILITY_INTEGRATION_KEY_LABELS = [
	{ key: "apiKey", label: "Api Key" },
];

export function persistSetupWebsiteId(websiteId) {
	if (websiteId == null) return;
	sessionStorage.setItem(SETUP_WEBSITE_ID_KEY, String(websiteId));
}

export function readSetupWebsiteId() {
	const raw = sessionStorage.getItem(SETUP_WEBSITE_ID_KEY);
	if (!raw) return null;
	const n = Number(raw);
	return Number.isFinite(n) ? n : raw;
}

export function clearSetupWebsiteId() {
	sessionStorage.removeItem(SETUP_WEBSITE_ID_KEY);
}

/** Active audit id from website integration keys (getUserDetail), if present */
export function getActiveAuditIdFromWebsite(website) {
	if (!website) return null;
	const keys = website.websiteKeys || website.keys;
	if (!Array.isArray(keys)) return null;
	const id = getValueForKey(keys, "aivisibilityAuditId");
	if (!id) return null;
	const n = Number(id);
	return Number.isFinite(n) ? n : id;
}
